import { render, staticRenderFns } from "./UpQuestionC.vue?vue&type=template&id=3d2f6a56&"
import script from "./UpQuestionC.vue?vue&type=script&lang=js&"
export * from "./UpQuestionC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports